module.exports = __webpack_public_path__ + "static/media/map-marker.2925ac11.svg";